import styled from 'styled-components'
import colorHelper from '../../../helpers/color'
import { Views } from '../../enums'
import { MV_DEFAULT_COLOR } from '../context/Context'

export enum ButtonFormat {
  inline = 'inline',
  inverse = 'inverse',
  primary = 'primary',
  secondary = 'secondary'
}

const Button = styled.div<ButtonProps>`
  width: 100%;
  max-width: 264px;
  height: 50px;
  padding-top: initial;
  padding-right: initial;
  padding-bottom: initial;
  padding-left: initial;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  text-transform: none;
  letter-spacing: normal;
  line-height: initial;
  ${({ color, format }) => format === ButtonFormat.primary && `
    color: ${color && color.toLowerCase() !== MV_DEFAULT_COLOR ? colorHelper(color) : '#FFFFFF'};
    background: ${color};
    border: 1px solid  ${color};
    border-radius: 25px;
  `}
  ${({ format }) => format === ButtonFormat.secondary && `
    color: #FFFFFF;
    background: #919191;
    border: 1px solid  #919191;
    border-radius: 25px;
  `}
  ${({ format }) => format === ButtonFormat.inverse && `
    color: #919191;
    background: #FFFFFF;
    border: 1px solid #919191;
    border-radius: 25px;
  `}
  ${({ view }) => view === Views.default && `
    @media(max-width: 767px) {
      height: 30px;
    }
  `}
  box-shadow: none;
  cursor: pointer;

  @media(max-width: 767px) {
    margin-right: 4px;
    margin-left: 4px;
  }
  &:active {
    box-shadow: none;
  }

  ${({ color, format }) => format === ButtonFormat.inline && `
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0;
    padding-top: 0;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 0;
    width: inherit;
    max-width: inherit;
    height: inherit;
    display: inline-block;
    border: 0;
    border-radius: none;
    background: transparent;
    background-color: transparent;
    color: #1E1E1E;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    text-align: inherit;
    text-decoration: underline;
    &:active,
    &:focus,
    &:focus-within,
    &:hover {
      color: #1E1E1E;
      background: initial;
      box-shadow: none;
    }
    @media(max-width: 767px) {
      margin-right: 0;
      margin-left: 0;
    }
  `}
`

export interface ButtonProps {
  color?: string
  format: string
  view?: Views
}

export default Button
